export const edgeGateways = [
	{
		id: '1',
		name: 'name',
		computerName: 'computer name',
		connectionType: 'cloud',
		tokenPrinting: true,
		version: '3.1.5',
		deviceCount: '50',
		lastConnected: 12341234,
	},
	{
		id: '2',
		name: 'Alpha Systems',
		computerName: 'ALPHA-WS-01',
		connectionType: 'cloud',
		tokenPrinting: false,
		version: '3.2.0',
		deviceCount: '24',
		lastConnected: 1716200012,
	},
	{
		id: '3',
		name: 'Beta Tech',
		computerName: 'BETA-SRV-22',
		connectionType: 'local',
		tokenPrinting: true,
		version: '3.1.8',
		deviceCount: '12',
		lastConnected: 1716201456,
	},
	{
		id: '4',
		name: 'Gamma Solutions',
		computerName: 'GAMMA-PC-77',
		connectionType: 'cloudLocal',
		tokenPrinting: false,
		version: '3.0.9',
		deviceCount: '38',
		lastConnected: 1716202987,
	},
	{
		id: '5',
		name: 'Delta Networks',
		computerName: 'DELTA-NODE-03',
		connectionType: 'cloud',
		tokenPrinting: true,
		version: '3.3.1',
		deviceCount: '65',
		lastConnected: 1716204123,
	},
	{
		id: '6',
		name: 'Echo Devices',
		computerName: 'ECHO-DESKTOP-9',
		connectionType: 'local',
		tokenPrinting: false,
		version: '3.1.2',
		deviceCount: '7',
		lastConnected: 1716205890,
	},
	{
		id: '7',
		name: 'Fusion Corp',
		computerName: 'FUSION-HOST-11',
		connectionType: 'cloudLocal',
		tokenPrinting: true,
		version: '3.4.0',
		deviceCount: '81',
		lastConnected: 1716207321,
	},
	{
		id: '8',
		name: 'Helix Group',
		computerName: 'HELIX-MAIN-02',
		connectionType: 'cloud',
		tokenPrinting: false,
		version: '3.2.7',
		deviceCount: '29',
		lastConnected: 1716208459,
	},
	{
		id: '9',
		name: 'Ion Industries',
		computerName: 'ION-CTRL-88',
		connectionType: 'local',
		tokenPrinting: true,
		version: '3.0.5',
		deviceCount: '14',
		lastConnected: 1716209988,
	},
	{
		id: '10',
		name: 'Jupiter Labs',
		computerName: 'JUPITER-OPS-5',
		connectionType: 'cloudLocal',
		tokenPrinting: false,
		version: '3.5.2',
		deviceCount: '103',
		lastConnected: 1716211200,
	},
	{
		id: '11',
		name: 'Krypton Systems',
		computerName: 'KRYPTON-EDGE-4',
		connectionType: 'cloud',
		tokenPrinting: false,
		version: '3.1.0',
		deviceCount: '44',
		lastConnected: 1716212881,
	},
];
